import {createSlice} from '@reduxjs/toolkit';

export const APP_STORE_NAME = 'app';

const initialState = {
  homeState: true,
  mainData: null,
  showCelebrate: false,
  showDisclaimerModal: true,
};

const appSlice = createSlice({
  name: APP_STORE_NAME,
  initialState,
  reducers: {
    setHomeState(state, {payload}) {
      state.homeState = payload;
    },
    setMainData(state, {payload}) {
      state.mainData = payload;
    },
    setShowCelebrate(state, {payload}) {
      state.showCelebrate = payload;
    },
    setShowDisclaimerModal(state, {payload}) {
      state.showDisclaimerModal = payload;
    },
  },
});

export const {actions, reducer} = appSlice;
